import React, { useEffect, useState } from 'react';
import { Typography, Paper, Grid, Avatar } from '@mui/material';
import { CakesInterface } from '../../../store/sellingCakeReport/api/interface';
import { IsNotNullOrEmpty, isValidArray } from '../../../utils/valid';
import { DisplayMode } from '../../../enum';
import { mergeImages } from '../../../utils/mergeImages';
import { getAssetURl } from '../../../utils/url';
import { useAppSelector } from '../../../store';
import Loader from '../../../components/Loader';

interface IProps {
  topSellingCakes: CakesInterface[] | undefined;
  lessSellingCakes: CakesInterface[] | undefined;
}

const Cakes: React.FC<IProps> = ({ topSellingCakes, lessSellingCakes }) => {
  const [topSellingCakeMergedImageUrl, setTopSellingCakeMergedImageUrl] =
    useState<any[]>([]);
  const [lessSellingCakeMergedImageUrl, setLessSellingCakeMergedImageUrl] =
    useState<any[]>([]);
  const assetUrl = useAppSelector(
    (state) => state.active.selectedItem.assetUrl
  );

  useEffect(() => {
    const fetchMergedImage = async () => {
      try {
        if (Array.isArray(topSellingCakes)) {
          const allMergedImages = await Promise.all(
            topSellingCakes?.map(async (item) => {
              if (
                IsNotNullOrEmpty(item) &&
                item?.displayMode === DisplayMode.front
              ) {
                if (
                  item?.shape?.frontImg &&
                  item?.flavor?.shapeImages?.[0]?.front
                ) {
                  const url = await mergeImages(
                    getAssetURl(item?.shape?.frontImg, assetUrl),
                    getAssetURl(
                      item?.flavor?.shapeImages?.[0]?.front,
                      assetUrl
                    ),
                    item?.colorCode,
                    getAssetURl(
                      item?.topping_category_item?.toppingShapeImages?.[0]
                        ?.front,
                      assetUrl
                    ),
                    getAssetURl(item?.shape?.frontColorImg, assetUrl)
                  );
                  return url;
                }
              } else if (
                IsNotNullOrEmpty(item) &&
                item?.displayMode === DisplayMode.top
              ) {
                if (
                  item?.shape?.topImg &&
                  item?.flavor?.shapeImages?.[0]?.top
                ) {
                  const url = await mergeImages(
                    getAssetURl(item?.shape?.topImg, assetUrl),
                    getAssetURl(item?.flavor?.shapeImages?.[0]?.top, assetUrl),
                    item?.colorCode,
                    getAssetURl(
                      item?.topping_category_item?.toppingShapeImages?.[0]?.top,
                      assetUrl
                    ),
                    getAssetURl(item?.shape?.topColorImg, assetUrl)
                  );
                  return url;
                }
              } else {
                return null;
              }
            })
          );
          setTopSellingCakeMergedImageUrl(allMergedImages);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchMergedImage();
  }, [topSellingCakes]);

  useEffect(() => {
    const fetchMergedImage = async () => {
      try {
        if (Array.isArray(lessSellingCakes)) {
          const allMergedImages = await Promise.all(
            lessSellingCakes?.map(async (item) => {
              if (
                IsNotNullOrEmpty(item) &&
                item?.displayMode === DisplayMode.front
              ) {
                if (
                  item?.shape?.frontImg &&
                  item?.flavor?.shapeImages?.[0]?.front
                ) {
                  const url = await mergeImages(
                    getAssetURl(item?.shape?.frontImg, assetUrl),
                    getAssetURl(
                      item?.flavor?.shapeImages?.[0]?.front,
                      assetUrl
                    ),
                    item?.colorCode,
                    getAssetURl(
                      item?.topping_category_item?.toppingShapeImages?.[0]
                        ?.front,
                      assetUrl
                    ),
                    getAssetURl(item?.shape?.frontColorImg, assetUrl)
                  );
                  return url;
                }
              } else if (
                IsNotNullOrEmpty(item) &&
                item?.displayMode === DisplayMode.top
              ) {
                if (
                  item?.shape?.topImg &&
                  item?.flavor?.shapeImages?.[0]?.top
                ) {
                  const url = await mergeImages(
                    getAssetURl(item?.shape?.topImg, assetUrl),
                    getAssetURl(item?.flavor?.shapeImages?.[0]?.top, assetUrl),
                    item?.colorCode,
                    getAssetURl(
                      item?.topping_category_item?.toppingShapeImages?.[0]?.top,
                      assetUrl
                    ),
                    getAssetURl(item?.shape?.topColorImg, assetUrl)
                  );
                  return url;
                }
              } else {
                return null;
              }
            })
          );
          setLessSellingCakeMergedImageUrl(allMergedImages);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchMergedImage();
  }, [lessSellingCakes]);

  return (
    <Paper
      elevation={3}
      sx={{ padding: 2, height: '100%' }}
    >
      <Typography
        variant='h6'
        gutterBottom
      >
        Cakes
      </Typography>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <Typography variant='subtitle1'>Most Sold</Typography>
        </Grid>
        {!isValidArray(topSellingCakes) && (
          <div className='center-class'>
            <Typography variant='body2'>{'No record found'}</Typography>
          </div>
        )}
        {topSellingCakes?.length !== topSellingCakeMergedImageUrl?.length &&
        isValidArray(topSellingCakes) ? (
          <Grid
            item
            xs={12}
          >
            <Loader />
          </Grid>
        ) : (
          topSellingCakes?.map((cake: CakesInterface, idx: number) => (
            <Grid
              item
              xs={6}
              key={cake?.labelEn}
            >
              <Avatar
                imgProps={{ crossOrigin: 'anonymous' }}
                src={topSellingCakeMergedImageUrl[idx]}
                sx={{
                  borderRadius: 'unset',
                  m: 1,
                  objectFit: 'contain',
                  '& img': { objectFit: 'contain' },
                  width: '100%',
                }}
              />
              <Typography
                variant='body1'
                align='center'
              >
                {cake?.labelEn} (Sold:{cake?.totalQuantitySold})
              </Typography>
            </Grid>
          ))
        )}
        {/* {topSellingCakes?.length !== topSellingCakeMergedImageUrl?.length
          ? topSellingCakes?.map((cake: CakesInterface, idx: number) => (
              <Grid
                item
                xs={6}
                key={cake?.labelEn}
              >
                <Avatar
                  imgProps={{ crossOrigin: 'anonymous' }}
                  src={topSellingCakeMergedImageUrl[idx]}
                  sx={{
                    borderRadius: 'unset',
                    m: 1,
                    objectFit: 'contain',
                    '& img': { objectFit: 'contain' },
                    width: '100%',
                  }}
                />
                <Typography
                  variant='body1'
                  align='center'
                >
                  {cake?.labelEn} (Sold:{cake?.totalQuantitySold})
                </Typography>
              </Grid>
            ))
          : isValidArray(topSellingCakes) && (
              <Grid
                item
                xs={12}
              >
                <Loader />
              </Grid>
            )} */}
        <Grid
          item
          xs={12}
        >
          <Typography variant='subtitle1'>Least Sold</Typography>
        </Grid>
        {!isValidArray(lessSellingCakes) && (
          <div className='center-class'>
            <Typography variant='body2'>{'No record found'}</Typography>
          </div>
        )}
        {/* {lessSellingCakes?.length !== lessSellingCakeMergedImageUrl?.length
          ? lessSellingCakes?.map((cake: CakesInterface, idx: number) => (
              <Grid
                item
                xs={6}
                key={cake?.labelEn}
              >
                <Avatar
                  imgProps={{ crossOrigin: 'anonymous' }}
                  src={lessSellingCakeMergedImageUrl[idx]}
                  sx={{
                    borderRadius: 'unset',
                    m: 1,
                    objectFit: 'contain',
                    '& img': { objectFit: 'contain' },
                    width: '100%',
                  }}
                />
                <Typography
                  variant='body1'
                  align='center'
                >
                  {cake?.labelEn} (Sold:{cake?.totalQuantitySold})
                </Typography>
              </Grid>
            ))
          : isValidArray(lessSellingCakes) && (
              <Grid
                item
                xs={12}
              >
                <Loader />
              </Grid>
            )} */}
        {lessSellingCakes?.length !== lessSellingCakeMergedImageUrl?.length &&
        isValidArray(lessSellingCakes) ? (
          <Grid
            item
            xs={12}
          >
            <Loader />
          </Grid>
        ) : (
          lessSellingCakes?.map((cake: CakesInterface, idx: number) => (
            <Grid
              item
              xs={6}
              key={cake?.labelEn}
            >
              <Avatar
                imgProps={{ crossOrigin: 'anonymous' }}
                src={lessSellingCakeMergedImageUrl[idx]}
                sx={{
                  borderRadius: 'unset',
                  m: 1,
                  objectFit: 'contain',
                  '& img': { objectFit: 'contain' },
                  width: '100%',
                }}
              />
              <Typography
                variant='body1'
                align='center'
              >
                {cake?.labelEn} (Sold:{cake?.totalQuantitySold})
              </Typography>
            </Grid>
          ))
        )}
      </Grid>
    </Paper>
  );
};

export default Cakes;
